import { parseCurrency } from '@helper/parseCurrency'

export const parsePlanOtbData = (data: any[]): any[] => {
  return data?.length === 0
    ? []
    : data.map((item, index) => {
        return {
          'plan-otb-id': index + 1,

          // 'empresa-periodo-id': item.periodo?.descricao
          //   ? item.periodo.descricao
          //   : '',
          'empresa-codigo-id': item.empresaId ? item.empresaId : 0,
          'empresa-ano': item.ano ? item.ano : '',
          'empresa-mes': item.mes ? item.mes : '',

          'categoria-compacta-codigo-id': item.categoriaCompactaId
            ? item.categoriaCompactaId
            : 0,
          // 'categoria-compacta-descricao-id': item.categoria?.categoriaCompacta
          //   ?.descricao
          //   ? item.categoria?.categoriaCompacta.descricao
          //   : '',

          'categoria-codigo-id': item.categoriaId ? item.categoriaId : 0,
          // 'categoria-descricao-id': item.categoria?.descricao
          //   ? item.categoria.descricao
          //   : '',

          'indicadores-estoque-inicial-id': item.estoqueInicial
            ? parseCurrency({
                value:
                  item.estoqueInicialAjustado > 0
                    ? item.estoqueInicialAjustado
                    : item.estoqueInicial,
                country: 'pt-br'
              })
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'indicadores-a-receber-id': item.aReceber
            ? parseCurrency({
                value: item.aReceber,
                country: 'pt-br'
              })
            : parseCurrency({ value: 0, country: 'pt-br' }),
          // 'indicadores-planej-pcl-id': item.vendasProjetadasPCL
          //   ? parseCurrency({
          //       value: item.vendasProjetadasPCL,
          //       country: 'pt-br'
          //     })
          //   : parseCurrency({ value: 0, country: 'pt-br' }),
          'indicadores-planej-projet-id': item.vendaProjetada
            ? parseCurrency({ value: item.vendaProjetada, country: 'pt-br' })
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'indicadores-compra-projet-id': item.compraProjetada
            ? parseCurrency({
                value: item.compraProjetada,
                country: 'pt-br'
              })
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'indicadores-estoque-final-id': item.estoqueFinal
            ? parseCurrency({ value: item.estoqueFinal, country: 'pt-br' })
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'indicadores-estoque-final-ajust-id': item.estoqueFinalAjustado
            ? item.estoqueFinalAjustado
            : 0,

          disabled: item.disabled
        }
      })
}
